import React, { Component } from 'react'

import USGovtHeader from './USGovernmentOfficialHeader'
import LgyLink from './util/lgy-link/LgyLink'
import HomeSideNav from '../gears/home/components/HomeSideNav'
import WelcomeGreeting from './WelcomeGreeting'
import AnnouncementsHeader from 'app/gears/announcements/containers/AnnouncementsHeader'

import '../style/lgy-header.scss'

import closeSvg from 'uswds/dist/img/close.svg'

class LgyHeader extends Component {

  clearCache = () => {
    // TODO: maybe this shouldn't live here, but this is more of an expirimental feature as I (Alex) write this
    console.log('clearing local cache')
    window.localStorage.setItem('lgyState', JSON.stringify({}))
  }

  render() {
    const { serverProperties, currentUser, trainingUrl } = this.props
    return (
      <div>
        {/* TODO: move this inline styling to lgy-header.scss*/}       
        <USGovtHeader />
        <header className='lgy-header usa-header usa-header-extended' role='banner'>
          <div className='usa-navbar usa-background-dark'>
            <div className='usa-logo' id='extended-logo'>
              <em className='usa-logo-text'>
                <LgyLink to='/lgyhub/' title='Welcome to Veterans Home Loan Guaranty Program' aria-label='Welcome to Veterans Home Loan Guaranty Program'>                  
                  <span className='lgy-logo-right-text'>Welcome to Veterans Home Loan Guaranty Program</span>
                </LgyLink>
              </em>
            </div>
            <button className='usa-menu-btn'>Menu</button>
            <nav role='navigation' className='usa-nav'>
              <div className='usa-nav-inner'>
                <button className='usa-nav-close'>
                  <img src={closeSvg} alt='close' />
                </button>
                <div className={`usa-nav-secondary ${currentUser.firstName ? 'adjust-height' : ''}`}>
                  {currentUser.firstName && <WelcomeGreeting user={currentUser} />}
                  <HomeSideNav currentUser={currentUser} trainingUrl={trainingUrl} />
                  <ul className='usa-unstyled-list usa-nav-secondary-links'>
                    <li>
                      <LgyLink title='Contact VA Customer Support' className='lgy-header-help' to='/lgyhub/help'>Contact VA Customer Support</LgyLink>
                    </li>
                    <li>
                      {/* Checking firstname because when a user is not yet registered but is coming through AccessVA, we will return their firstname. 
                      So this will cover the corner case where a user is coming through AccessVA but registration fails for them. */}
                      {currentUser.firstName && serverProperties.eauthUrl &&
                         <a className='lgy-header-sign-out' onClick={this.clearCache} href={serverProperties.eauthUrl + '/pkmslogout?filename=lgyhub-logout.html'}>Sign Out</a>
                        }
                    </li>
                  </ul>
                </div>
              </div>
            </nav>
          </div>
          {!currentUser.firstName && <AnnouncementsHeader />}
        </header>
      </div>
    )
  }
}

export default LgyHeader
